<app-navigation-header title="Add User" [detail]="company?.name" svgName="sl-add" i18n-title="@@addUserMainTab-addUser">
	<div class="mat-stepper-navigator">
		@if (stepperRef.selectedIndex !== 2) {
			<button
				mat-button
				(click)="movePrevious(stepperRef)"
				class="secondary-stepper-button"
				i18n="@@addUserMainTab-cancelButton"
				data-automation-id="add-user-back-button"
			>
				Back
			</button>
		}
		@if (stepperRef.selectedIndex !== 2) {
			<button
				mat-flat-button
				[disabled]="
					continueDisabled ||
					serverCallInProgress ||
					(stepperRef.selectedIndex === 1 && !isStepOneButtonIsAbleToContinue())
				"
				(click)="moveNext(stepperRef)"
				class="primary-stepper-button"
				i18n="@@addUserMainTab-continueButton"
				data-automation-id="add-user-ontinue-button"
			>
				Continue
			</button>
		}
	</div>
	<mat-horizontal-stepper linear #stepperRef>
		<ng-template matStepperIcon="edit">
			<mat-icon>check</mat-icon>
		</ng-template>
		<mat-step>
			<ng-template matStepLabel i18n="@@1/About">About</ng-template>
			<app-add-user-about (selectedUserEvents)="onSelectedUserEvent($event)"> </app-add-user-about>
		</mat-step>

		<mat-step>
			<ng-template matStepLabel i18n="@@2/AssignRole">Assign Role</ng-template>
			<app-add-user-assign-role
				[companyId]="companyId"
				[userEvent]="userEvent"
				(selectedCompanyRoleEvents)="onSelectedCompanyRoleEvent($event)"
			>
			</app-add-user-assign-role>
		</mat-step>

		<mat-step>
			<ng-template matStepLabel i18n="@@3/Confirmation">Confirmation</ng-template>
			<app-add-user-confirmation [companyId]="companyId" [addUserRequestStatusEvents]="addUserRequestStatusEvents">
			</app-add-user-confirmation>
		</mat-step>
	</mat-horizontal-stepper>
</app-navigation-header>
